const _ = require("lodash");
const moment = require("moment");
const Analytics = require("../util/Analytics");

const {setIn} = require("../../../shared/ImmHelpers");
const {atCart, atMarketing} = require("./StateCursors");

const saveMarketingNow = function(marketing, api) {
	const events = marketing.eventList;
	if (events.length && isReadyToSave(marketing)) {
		api.logMarketingEvents(marketing.eventList);
	}
};

// Returns false if fillMissingValues still needs to finish some events.
const isReadyToSave = function(marketing) {
	return _.every(marketing.eventList, evt => {
		if (evt.type === "StartCart" || evt.type === "AddToCart") {
			return !!evt.eventRefID;
		}
		return true;
	});
};

const fillMissingValues = function(state) {
	const cart = atCart(state).get();
	return atMarketing(state).setIn(["eventList"], el => {
		// Other functions rely on this returning the original state when no
		// changes are made. To avoid .map always defeating this check, we track
		// manually whether changes are made.
		let hasChanges = false;
		const newEl = el.map(evt => {
			if (evt.type === "StartCart" || evt.type === "AddToCart") {
				if (!evt.eventRefID && cart && cart.cartID) {
					hasChanges = true;
					evt = setIn(evt, "eventRefID", cart.cartID);
				}
			}
			return evt;
		});
		return hasChanges ? newEl : el;
	});
};

const setupThrottlerInVault = function(vault) {
	const {api, throttler} = vault;

	throttler.config("marketing", {
		delay: 5000,
		run: marketing => saveMarketingNow(marketing, api),
	});
};

const init = function(origMarketing) {
	return {
		eventList: _.get(origMarketing, "eventList", []),
	};
};

const addEventToQueue = function(
	state,
	type,
	eventRefID,
	cookie,
	throttler,
	clock
) {
	state = atMarketing(state).set(marketing => {
		if (!Analytics.isActive()) return marketing;
		marketing = setIn(marketing, "eventList", el =>
			el.concat([
				{
					type,
					eventRefID,
					clientDeviceID: Analytics.getClientDeviceID(cookie),
					timestamp: moment(clock.now()).format(),
				},
			])
		);
		throttler.queue("marketing", marketing);
		return marketing;
	});
	return state;
};

const handleSaveSuccess = function(marketing, payload) {
	const savedList = payload.events;
	const maxTimestamp = _.maxBy(savedList, evt =>
		moment(evt.timestamp).valueOf()
	);
	if (savedList.length) {
		marketing = setIn(marketing, "eventList", el => {
			return el.filter(evt => moment(evt.timestamp).valueOf() <= maxTimestamp);
		});
	}
	return marketing;
};

const handleSaveFail = function(marketing, payload, error, throttler) {
	throttler.queue("marketing", marketing);
	return marketing;
};

// Called every action
const recordEvents = function(vault, oldState, newState, action) {
	const origNewState = newState;
	newState = fillMissingValues(newState);
	if (origNewState !== newState) {
		vault.throttler.queue("marketing", atMarketing(newState).get());
	}
	return newState;
};

module.exports = {
	setupThrottlerInVault,
	init,
	addEventToQueue,
	handleSaveSuccess,
	handleSaveFail,
	recordEvents,
};
